import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import Icon from "@insite/mobius/Icon";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import React from "react";
import styled, { css } from "styled-components";

const errorStyleMixin = css`
    position: relative;
    padding-left: ${styleHelpers.rem(20)};
    &::before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: ${styleHelpers.rem(2)};
        height: 100%;
        background-color: ${styleConstants.colours.errorRed};
    }
`;

export const textFieldErrorStyle = (
    isError: boolean,
    textFieldMergeStyle: Partial<TextFieldPresentationProps> = {}
) => {
    if (!isError) {return textFieldMergeStyle}

    if (!textFieldMergeStyle.cssOverrides) { textFieldMergeStyle.cssOverrides = {} }
    
    textFieldMergeStyle.cssOverrides.formField = css`
        ${textFieldMergeStyle.cssOverrides.formField}
        ${errorStyleMixin};
    `;
    return textFieldMergeStyle;
}

type Props = {
    text: string;
    extendedCss? : string;
}

/**
 * Strong red error
 */
export const ErrorStrong:React.FC<Props> = (
    {text, extendedCss = ""}
) => {

    const Wrapper = styled.div`
        position:relative;
        left:0;
        width: 100%;
        height: auto;
        display: flex;
        flex-flow: row nowrap;
        padding: 15px 20px;
        background-color: ${styleConstants.colours.errorRed};
        border-radius: ${styleHelpers.rem(5)};
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
    `;
    const ExtendWrapper = styled(Wrapper)`${extendedCss}`;

    
    const ErrorText = styled.p`
        font-size: ${styleHelpers.rem(16)};
        line-height: ${26/18};
        font-weight: 600;
        text-align: start;
        margin: 0 0 0 10px;
        color: ${styleConstants.colours.white};
    `;
    return(
        <ExtendWrapper>
            <Icon src="AlertCircle" color={styleConstants.colours.white} />
            <ErrorText>
                {text}
            </ErrorText>
        </ExtendWrapper>
    );
};